import {useParams} from 'react-router-dom'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../parts/crud/List'
import {ActionType, ColumnType} from '../../../parts/crud/Types'
import {useEffect, useState} from 'react'
import {processGet, processPatch} from '../../../../services/api'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

export const LicencesViewList = () => {
  const {id} = useParams()
  const [name, setName] = useState('')
  const [group, setGroup] = useState('')
  useEffect(() => {
    const fetchUser = async () => {
      let licence: any = await processGet('licences/' + id)
      setName(licence.data.name)
      setGroup(licence.data.fk_group_id.label)
    }
    fetchUser()
  }, [id])

  let api = 'licences/' + id + '/view'
  const columns: Array<ColumnType> = [
    {title: 'Codice', key: 'code', type: 'text', orderable: true},
    {title: 'Server', key: 'server_host', type: 'text', orderable: true},
    {title: 'Attivata il', key: 'license_start', type: 'datetime', orderable: true},
    {title: 'Scadenza', key: 'license_end', type: 'datetime', orderable: true},
    {title: 'Pacchetto', key: 'name', type: 'text', orderable: true},
  ]

  const MenuActions: ActionType[] = [
    {
      title: 'Dissocia',
      type: 'link',
      action: 'unbind',
      icon: 'fa-solid fa-link-slash',
      condition: (item: any) => item.server_host !== null,
    },
    {
      type: 'divider',
      condition: (item: any) => item.server_host !== null,
    },
    {
      title: 'Elimina',
      type: 'link',
      action: 'delete',
      textColor: 'danger',
      icon: 'fa-solid fa-trash',
    },
  ]
  const unbind = (code: string) => {
    MySwal.fire({
      title: 'Disassocia licenza',
      text: 'Sei sicuro di voler disassociare questa licenza?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, dissocia',
      cancelButtonText: 'No, annulla',
    }).then(async (response: any) => {
      if (response.value) {
        await processPatch('licences/' + code + '/unbind', {})
        MySwal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer
            toast.onmouseleave = Swal.resumeTimer
          },
          icon: 'success',
          title: 'Licenza disassociata con successo',
        })
      }
    })
  }
  return (
    <>
      <CrudProvider api={api}>
        <ListComponent
          menuClicked={(action, data) => {
            if (action === 'unbind') {
              unbind(data.code)
              return false
            }
            return true
          }}
          columns={columns}
          defOrder='server_host'
          defOrderDir='desc'
          newButton={false}
          title={`Pacchetto licenze: ${name} - ${group}`}
          actions={MenuActions}
        />
      </CrudProvider>
    </>
  )
}
